var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgFilterAlt = function SvgFilterAlt(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 17,
    viewBox: "0 0 14 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.07831 4.43175C3.35668 6.09362 5.72165 9.1617 5.72165 9.1617V12.9968C5.72165 13.3164 5.97732 13.636 6.36083 13.636H7.63919C8.0227 13.636 8.27838 13.3164 8.27838 12.9968V9.1617C8.27838 9.1617 10.6433 6.09362 11.9217 4.43175C12.3052 3.98432 11.9856 3.40906 11.4743 3.40906H2.52574C2.01439 3.40906 1.6948 3.98432 2.07831 4.43175Z",
    fill: "var(--iconColor, currentColor)"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgFilterAlt);
export { ForwardRef as ReactComponent };